import { render } from "./HRMSChatBox.vue?vue&type=template&id=8b7436aa&scoped=true"
import script from "./HRMSChatBox.vue?vue&type=script&lang=js"
export * from "./HRMSChatBox.vue?vue&type=script&lang=js"

import "./HRMSChatBox.vue?vue&type=style&index=0&id=8b7436aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7436aa"]])

export default __exports__